function getDataUri(url, callback) {
    var image = new Image();
    image.crossOrigin = "Anonymous";
    image.onerror = function () {
      callback();
    };
    image.onload = function () {
        var canvas = document.createElement('canvas');
        if (this.naturalWidth > 600) {
          canvas.width = 600
          canvas.height = (600 / this.naturalWidth) * this.naturalHeight
        } else {
          canvas.width = this.naturalWidth
          canvas.height = this.naturalHeight
        }
        // canvas.width = this.naturalWidth; // or 'width' if you want a special/scaled size
        // canvas.height = this.naturalHeight; // or 'height' if you want a special/scaled size

        canvas.getContext('2d').drawImage(this, 0, 0);

        // ... or get as Data URI
        callback({dataUrl: canvas.toDataURL('image/png'), width: canvas.width, height: canvas.height});
    };

    image.src = url;
}

function P (url) {
  return new Promise(function (resolve) {
    return getDataUri(url, resolve);
  })
}

function img2datauri (images) {
  images = Array.isArray(images) ? images : [images];

  return Promise.all(images.map(P));
}

module.exports = img2datauri;




/** WEBPACK FOOTER **
 ** ./src/app/helpers/downloadClipping/img2datauri.js
 **/